import * as React from "react";
import {
  IconButton,
  Dialog,
  DialogType,
  DialogFooter,
  PrimaryButton,
  DefaultButton
} from "office-ui-fabric-react";
import ReactDOM = require("react-dom");
import SignIn from "./SignIn";
import App from "./App";

export interface HeaderProps {
  title: string;
  isLoggedIn: boolean;
}

export interface HeaderState {
  hideDialog: boolean;
}

class Header extends React.Component<HeaderProps, HeaderState> {
  constructor(props, {}) {
    super(props, {});
    this.state = {
      hideDialog: true
    };
  }
  render() {
    return (
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
            style={{ backgroundColor: "#188DC5", height: 40 }}
          >
            <span
              style={{
                color: "white",
                float: "left",
                marginTop: 10,
                marginLeft: 5,
                fontFamily: "Lato",
                fontSize: 16,
                fontWeight: "normal"
              }}
            >
              {this.props.title}
            </span>
            <IconButton
              styles={{ menuIcon: { fontSize: 0 } }}
              style={{
                float: "right",
                color: "white",
                marginTop: 5
              }}
              data-automation-id="test"
              iconProps={{ iconName: "CollapseMenu" }}
              text="Logout"
              menuProps={{
                items: [
                  {
                    key: "logOut",
                    name: "Logout",
                    iconProps: { iconName: "SignOut", title: "Logout" },
                    onClick: this.showConfirmLogOut
                  },
                  {
                    key: "clearrecentmatters",
                    name: "Clear Recent Matters",
                    iconProps: {
                      iconName: "Cancel",
                      title: "Clear Recent Matters"
                    },
                    onClick: this.clearRecentMatters
                  }
                ]
              }}
            />
          </div>
        </div>
        <Dialog
          hidden={this.state.hideDialog}
          onDismiss={this.closeConfirmDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Confirm Logout",
            subText: "Are you sure you want to logout?"
          }}
          modalProps={{
            titleAriaId: "myLabelId",
            subtitleAriaId: "mySubTextId",
            isBlocking: false,
            containerClassName: "ms-dialogMainOverride"
          }}
        >
          <DialogFooter>
            <PrimaryButton
              onClick={this.confirmLogOut}
              text="Yes"
              style={{
                fontFamily: "Lato",
                fontWeight: "normal",
                color: "white",
                fontSize: 14,
                backgroundColor: "#0E3A6E"
              }}
            />
            <DefaultButton
              onClick={this.closeConfirmDialog}
              text="No"
              style={{
                fontFamily: "Lato",
                fontWeight: "normal",
                color: "black",
                fontSize: 14
              }}
            />
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
  //show dialog box when click on logout btn
  showConfirmLogOut = () => {
    this.setState({ hideDialog: false });
  };
  //close dialog box
  closeConfirmDialog = () => {
    this.setState({ hideDialog: true });
  };
  //confirm logout by click on 'yes'
  confirmLogOut = () => {
    this.setState({ hideDialog: true });
    let settings = Office.context.roamingSettings;
    settings.remove("accessTokenObj");
    settings.saveAsync(function(asyncResult) {
      if (asyncResult.status == Office.AsyncResultStatus.Failed) {
        console.error("Outlook failed to save removal of accessTokenObj...");
      } else {
        ReactDOM.render(<SignIn />, document.getElementById("container"));
      }
    });
  };
  clearRecentMatters = () => {
    let self = this;
    let settings = Office.context.roamingSettings;
    settings.set("SelectedMattersList", undefined);
    settings.saveAsync(function(asyncResult) {
      if (asyncResult.status == Office.AsyncResultStatus.Failed) {
        console.error("Outlook failed to save clearing of SelectedMattersList...");
      } else {
        ReactDOM.render(
          <App
            title={"SimpleLegal"}
            isOfficeInitialized={true}
            savedMatters={[]}
            isItemChanged={false}
            isLoggedIn={self.props.isLoggedIn}
          />,
          document.getElementById("container")
        );
      }
    });
  };
}

export default Header;
